// extracted by mini-css-extract-plugin
module.exports = {"section":"_22gI2","teamLogoImg":"_2wCHQ","teamInfo":"_1_Jxz","teamLink":"_2q-U_","teamName":"zCdpS","teamDebut":"_2ofU7"};